import { render, staticRenderFns } from "./RegisterAgreement.vue?vue&type=template&id=26f0e5a6&scoped=true&"
var script = {}
import style0 from "./RegisterAgreement.vue?vue&type=style&index=0&id=26f0e5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0e5a6",
  null
  
)

export default component.exports